import { useRef, useState } from "react";
import { C } from "../theme/colors";

export default function DonutChartV2({ segments }) {
  const [hovered, setHovered] = useState(null);
  const svgRef = useRef(null);

  const SIZE = 200;
  const cx = SIZE / 2, cy = SIZE / 2;
  const R = 68, stroke = 32;
  const circ = 2 * Math.PI * R;
  const total = segments.reduce((s, d) => s + d.v, 0);

  let cum = 0;
  const arcs = segments.map((seg, i) => {
    const pct = seg.v / total;
    const start = cum;
    cum += pct;
    return { ...seg, pct, start, index: i };
  });

  return (
    <div style={{display:"flex",gap:20,alignItems:"center",flexWrap:"wrap"}}>
      {/* SVG Donut */}
      <div style={{flexShrink:0,position:"relative"}}>
        <svg
          ref={svgRef}
          width={SIZE} height={SIZE}
          viewBox={`0 0 ${SIZE} ${SIZE}`}
          style={{display:"block",overflow:"visible"}}
          onMouseLeave={() => setHovered(null)}
        >
          {arcs.map((arc, i) => {
            const dash   = arc.pct * circ;
            const gap    = circ - dash;
            const offset = -(arc.start * circ);
            const isHov  = hovered === i;
            return (
              <circle
                key={i}
                cx={cx} cy={cy} r={R}
                fill="none"
                stroke={arc.c}
                strokeWidth={isHov ? stroke + 8 : stroke}
                strokeDasharray={`${dash} ${gap}`}
                strokeDashoffset={offset}
                transform={`rotate(-90 ${cx} ${cy})`}
                style={{cursor:"pointer",transition:"stroke-width .18s ease"}}
                onMouseEnter={() => setHovered(i)}
                onMouseMove={() => setHovered(i)}
              />
            );
          })}

          {/* White centre hole */}
          <circle cx={cx} cy={cy} r={R - stroke/2 - 3} fill="white"/>

          {/* Centre text */}
          {hovered !== null ? (
            <>
              <text x={cx} y={cy - 8} textAnchor="middle" dominantBaseline="middle"
                fontFamily="Arial,Helvetica,sans-serif" fontSize="20" fontWeight="800"
                fill={arcs[hovered].c}>
                {arcs[hovered].v}%
              </text>
              <text x={cx} y={cy + 13} textAnchor="middle" dominantBaseline="middle"
                fontFamily="Arial,Helvetica,sans-serif" fontSize="9.5" fontWeight="500"
                fill="#6B7A9B">
                {arcs[hovered].label.length > 14
                  ? arcs[hovered].label.slice(0,14) + "…"
                  : arcs[hovered].label}
              </text>
            </>
          ) : (
            <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle"
              fontFamily="Arial,Helvetica,sans-serif" fontSize="10" fill="#9CA3AF">
              Hover to explore
            </text>
          )}
        </svg>
      </div>

      {/* Legend — clean stacked rows, no SVG lines */}
      <div style={{display:"flex",flexDirection:"column",gap:6,flex:1,minWidth:110}}>
        {arcs.map((arc, i) => (
          <div
            key={i}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            style={{
              display:"flex", alignItems:"center", gap:8,
              padding:"5px 8px", borderRadius:6, cursor:"pointer",
              background: hovered === i ? `${arc.c}15` : "transparent",
              transition:"background .15s",
            }}
          >
            <div style={{
              width:11, height:11, borderRadius:3,
              background:arc.c, flexShrink:0,
              transform: hovered === i ? "scale(1.3)" : "scale(1)",
              transition:"transform .15s",
            }}/>
            <span style={{
              fontFamily:"Arial,Helvetica,sans-serif",
              fontSize:11.5,
              color: hovered === i ? arc.c : C.textMid,
              fontWeight: hovered === i ? 700 : 400,
              transition:"color .15s",
              lineHeight:1.3,
            }}>
              {arc.label} — {arc.v}.00%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
